<template>
<div>
    <div class="mcc-page-header mu-d-flex">
        <section class="mu-d-flex mu-w-100">
            <div class="mu-d-flex mu-w-100">
                <h1 class="mu-mb-00">Licence management</h1>
                <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">
 
                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
            </div>
        </section>
    </div>
    <div class="mu-pl-07 mu-pt-05">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Administration </li>
                <li> Licence management</li>
            </ol>
        </nav>
    </div>
    <div class="mu-px-07 mu-pb-07">
        <div class="mcc-row">
            <div class="mcc-col mcc-col-xs-12 mcc-col-md-12 mcc-col-sm-12">
                <div style="position: relative">
                    <div v-if="!updateCall" class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                    <form id="formId" novalidate @submit.prevent="updateLicenseInfo()">
                        <div class="mcc-card">
                            <div class="mcc-card__header">
                                <h2 class="mcc-card__title  ">Details</h2>
                            </div>
                            <div class="mcc-card__body">
                                <div class="mcc-row">
                                    <div class="mcc-col">
                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container  mfc-form-input-wrapper--width mu-mb-05 ">
                                            <label class="mfc-label mfc-label--required" for="organizationName">Organisation name</label>
                                            <input type="text" ref="name" id="name" name="name" required="" :value="dto.organizationName" placeholder="Organisation name" maxlength="255" :pattern="descRegex" @change="updateOrganizationName($event)">
                                        </div>
                                        <div class="mfc-input-wrapper mfc-form-input-container mu-mb-05  mfc-form-input-wrapper--width">
                                            <label class="mfc-label mfc-label--required" for="organizationEmail">Organisation email</label>
                                            <div class="mfc-input-group mfc-input-group--leading-icon">
                                                <mcc-icon class="mfc-input-group__icon mcc-icon" name="secured_letter" aria-hidden="true"></mcc-icon>
                                                <input type="email" required="" ref="email" :value="dto.organizationEmail" name="email" maxlength="255" id="email" @change="updateOrganizationEmail($event)">
                                                <div class="mfc-invalid-feedback"></div>

                                            </div>
                                        </div>
                                        <div class="mfc-textarea-wrapper  mfc-form-input-container mfc-form-input-wrapper--width">
                                            <label class="mfc-label mfc-label--required" for="licenseKey">License key</label>
                                            <textarea required="" id="licenseKey" ref="licenseKey" placeholder="License key" name="licenseKey" :value="dto.licenseKey" character-count="" maxlength="1000" @input="dto.licenseKey = $event.target.value" @change="validateLicenseKey($event)"></textarea>
                                            <div class="mfc-invalid-feedback"></div>

                                            <span class="mfc-help-text" v-if="dto.licenseKey">  You have {{1000 - dto.licenseKey.length}} characters remaining</span>
                                            <span class="mfc-help-text" v-else> You have 1000 characters remaining</span>
                                        </div>
                                        <div class="mfc-input-wrapper  mfc-form-input-container  mfc-form-input-wrapper--width mu-mb-05" v-show="dto.expiryDate != ''">
                                            <label for="expiryDate">Expiry date</label>
                                             <div class="mfc-input-group mfc-input-group--trailing-icon">
                                                <input type="text" id="expiryDate" ref="expiryDate" name="expiryDate" placeholder="Expiry date" :value="dto.expiryDate" disabled="">
                                                <button type="button" class="mcc-button mcc-button--outline" data-toggle aria-label="date" disabled="">
                                                                    <mcc-icon name="calendar" aria-hidden="true"></mcc-icon>
                                                                </button>                                            </div>
                                        </div>
                                        <div class="mu-d-flex mu-justify-content-end d-flex justify-content-end" >
                                            <button class="mcc-button mcc-button--success" id="saveLicenseKeyBtn" title="Save" type="submit">
                                                <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import LicenseManagementAPI from "../../../services/LicenseManagementAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from "../../../formvalid";

export default {
    name: "LicenseInfo",
    data() {
        return {
            dto: {
                expiryDate: "",
                licenseKey: "",
                organizationEmail: "",
                organizationName: "",
            },
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            helpText: constantMessages.BREADCRUMB_HELP["license.create"],
            descRegex: constantMessages.PATTERNS["description"],
            updateCall: false,
            showHelpText: false,
            emailRegex: constantMessages.PATTERNS["email"]
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        this.getLicenseInfo();
    },
    methods: {
        getLicenseInfo() {
            let self = this;
            LicenseManagementAPI.getLicenseInfo().then((response) => {
                if (response.status == null) {
                    self.dto = response;
                } else {
                    self.dto = response.data;
                    EventBus.$emit("error-notification", {
                        msg: constantMessages.MESSAGES["license.key.invalid"],
                    });
                }
                if (self.dto.expiryDate != "") {
                    self.dto.expiryDate = moment(
                        self.dto.expiryDate,
                        "YYYY-MM-DD"
                    ).format("DD/MM/YYYY");
                }
                self.updateCall = true;
            });
        },
        updateLicenseInfo() {

            let form = $('#formId')

            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            let self = this;
            self.updateCall = false;
            LicenseManagementAPI.updateLicenseInfo(this.dto).then((response) => {
                self.updateCall = true;
                if (response.status != null) {
                    if (response.status == 500) {
                        displayErrorMessage($(self.$refs.licenseKey), constantMessages.MESSAGES[response.data])
                        self.$refs.licenseKey.classList.add("ms-is-invalid")
                        return;
                    }
                    if (response.status == 400) {
                        for (let k in response.data.messages) {
                            if (k == "email") {
                                displayErrorMessage($(self.$refs.email), constantMessages.MESSAGES[response.data.messages[k]])
                                self.$refs.email.classList.add("ms-is-invalid")
                            } else if (k == "name") {
                                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.data.messages[k]])
                                self.$refs.name.classList.add("ms-is-invalid")
                            } else if (k == "licenseKey") {
                                displayErrorMessage($(self.$refs.licenseKey), constantMessages.MESSAGES[response.data.messages[k]])
                                self.$refs.licenseKey.classList.add("ms-is-invalid")
                            }
                        }
                    }
                } else {
                    self.$refs.licenseKey.classList.remove("ms-is-invalid")
                    self.$refs.name.classList.remove("ms-is-invalid")
                    self.$refs.email.classList.remove("ms-is-invalid")
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response],
                    });
                    self.getLicenseInfo();
                }
            });
        },
        updateOrganizationName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["license.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 255) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["license.name.length"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }
            self.dto.organizationName = event.target.value;
        },
        updateOrganizationEmail(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.email), constantMessages.MESSAGES["license.email.required"])
                self.$refs.email.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 255) {
                displayErrorMessage($(self.$refs.email), constantMessages.MESSAGES["license.email.length"])
                self.$refs.email.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.emailRegex)) {
                displayErrorMessage($(self.$refs.email), constantMessages.MESSAGES["license.email.invalid"])
                self.$refs.email.classList.add("ms-is-invalid")
            } else {
                self.$refs.email.classList.remove("ms-is-invalid")
            }
            self.dto.organizationEmail = event.target.value;
        },
        validateLicenseKey(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.licenseKey), constantMessages.MESSAGES["license.key.required"])
                self.$refs.licenseKey.classList.add("ms-is-invalid")
            } else {
                self.$refs.licenseKey.classList.remove("ms-is-invalid")
            }
        }
    },
};
</script>
<style>
.mfc-input-wrapper .mfc-input-group--leading-icon .mfc-input-group__icon {
    padding: 0.5rem 0.5rem 0.5rem 0.75rem !important;
}
</style>
